import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { AuditDialog } from 'src/modules/supply_chain/components/AuditDialog'
import { skuit } from 'src/services/skuit'

import { AuditListTable } from 'src/components/Table/list/Audit'
import { ListPage } from 'src/components/Pages/ListPage'

export const AuditListPage = () => {
  const paginator = useQueryPaginator('audit-list', skuit.sc.audits.list)

  return (
    <ListPage
      title='Audits'
      paginator={paginator}
      dialogs={[{ title: 'New Audit', Dialog: AuditDialog }]}
    >
      <AuditListTable
        paginator={paginator}
        fields={['name', 'facility', 'auditType', 'sku', 'createdOn', 'status', 'accuracyScore']}
      />
    </ListPage>
  )
}
